export const DESTROY_FILES_SESSION = 'dt/files/DESTROY_FILES_SESSION';
export const REFRESH_SESSIONS = 'dt/files/REFRESH_SESSIONS';
export const REQUEST_FILES = 'dt/files/REQUEST_FILES';
export const REQUEST_INSTRUCTIONALS = 'dt/files/REQUEST_INSTRUCTIONALS';
export const RECEIVE_FILES = 'dt/files/RECEIVE_FILES';
export const RECEIVE_INSTRUCTIONALS = 'dt/files/RECEIVE_INSTRUCTIONALS';
export const DELETE_FILE = 'dt/files/DELETE_FILE';
export const DELETE_FILE_SUCCESS = 'dt/files/DELETE_FILE_SUCCESS';
export const UPDATE_FILES = 'dt/files/UPDATE_FILES';
export const UPLOAD_FILES = 'dt/files/UPLOAD_FILES';
export const UPLOAD_FILE_STARTED = 'dt/files/UPLOAD_FILE_STARTED';
export const UPLOAD_FILE_COMPLETED = 'dt/files/UPLOAD_FILE_COMPLETED';
export const CLEAR_UPLOADED = 'dt/files/CLEAR_UPLOADED';
export const ZIP_FILES = 'dt/files/ZIP_FILES';
export const CREATE_BOOKMARK_SUCCESS = 'dt/files/CREATE_BOOKMARK_SUCCESS';
export const UPDATE_BOOKMARK_SUCCESS = 'dt/files/UPDATE_BOOKMARK_SUCCESS';
export const DELETE_BOOKMARK_SUCCESS = 'dt/files/DELETE_BOOKMARK_SUCCESS';
export const DOWNLOAD_FILES = 'dt/files/DOWNLOAD_FILES';

export const destroyFilesSession = (sessionId) => ({
  type: DESTROY_FILES_SESSION,
  sessionId,
});

// Refresh all active sessions by re-fetching files using last used query settings.
export const refreshSessions = () => ({
  type: REFRESH_SESSIONS,
});

export const requestFiles = (sessionId, query) => ({
  type: REQUEST_FILES,
  sessionId,
  query,
});

export const requestInstructionals = () => ({
  type: REQUEST_INSTRUCTIONALS,
});

export const receiveFiles = (sessionId, files, pages, query) => ({
  type: RECEIVE_FILES,
  sessionId,
  files,
  pages,
  query,
});

export const receiveInstructionals = (files) => ({
  type: RECEIVE_INSTRUCTIONALS,
  files,
});

export const uploadFileStarted = (file) => ({
  type: UPLOAD_FILE_STARTED,
  file,
});

export const uploadFileCompleted = (file, status) => ({
  type: UPLOAD_FILE_COMPLETED,
  file,
  status,
});

export const clearUploaded = () => ({
  type: CLEAR_UPLOADED,
});

export const zipFiles = (files) => ({
  type: ZIP_FILES,
  files,
});

export const uploadFiles = (siteId, files, org) => ({
  type: UPLOAD_FILES,
  siteId,
  files,
  org,
});

export const updateFiles = (siteId, files, org) => ({
  type: UPDATE_FILES,
  siteId,
  files,
  org,
});

export const deleteFile = (fileId) => ({
  type: DELETE_FILE,
  fileId,
});

export const deleteFileSuccess = (fileId) => ({
  type: DELETE_FILE_SUCCESS,
  fileId,
});

export const createBookmarkSuccess = ({ fileId, bookmark }) => ({
  type: CREATE_BOOKMARK_SUCCESS,
  fileId,
  bookmark,
});

export const updateBookmarkSuccess = ({ fileId, bookmarkId, bookmark }) => ({
  type: UPDATE_BOOKMARK_SUCCESS,
  fileId,
  bookmarkId,
  bookmark,
});

export const deleteBookmarkSuccess = ({ fileId, bookmarkId }) => ({
  type: DELETE_BOOKMARK_SUCCESS,
  fileId,
  bookmarkId,
});

/**
 * Download one or more files.
 * @param {Object|Array|String} fileOrFiles - file object, array of files
 * @param {String} [filename] - Optional filename for download
 */
export const downloadFiles = (fileOrFiles, filename) => ({
  type: DOWNLOAD_FILES,
  fileOrFiles,
  filename,
});
